import { Pie, mixins } from "vue-chartjs";
import isEqual from "lodash.isequal";
const { reactiveProp } = mixins;
export default {
  extends: Pie,
  mixins: [reactiveProp],
  props: {
    options: {
      type: Object,
      default() {
        return {};
      }
    },
    chartData: {
      type: Object,
      required: false
    },
    headline: {
      type: String,
      default: () => "Kanäle"
    }
  },
  mounted() {
    this.updateChart();
  },
  watch: {
    chartData(value, oldValue) {
      if (!value) {
        return;
      }

      if (value && (!oldValue || !isEqual(value, oldValue))) {
        this.updateChart(value);
      }
    }
  },
  data() {
    return {
      legendItems: {}
    };
  },
  methods: {
    updateChart(value) {
      if (!value) {
        return;
      }
      this.renderChart(
        value,
        Object.assign(
          {
            title: {
              display: true,
              text: this.headline
            },
            responsive: true,
            interaction: {
              intersect: false
            }
          },
          this.options
        )
      );
    }
  }
};
